import { render } from "./QuizFinish.vue?vue&type=template&id=7d7ae42c"
import script from "./QuizFinish.vue?vue&type=script&lang=js"
export * from "./QuizFinish.vue?vue&type=script&lang=js"

import "./QuizFinish.vue?vue&type=style&index=0&id=7d7ae42c&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__